var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFintechhub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 20,
    viewBox: "0 0 258 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0390625 0.381044V21.9998H5.31409V12.966H22.0607V8.66721H5.31409V4.67988H22.5691V0.381044H0.0390625Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0539 0.381044H26.7789V21.9998H32.0539V0.381044Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5067 0.381044V21.9998H41.7817V4.67988H42.5126L55.7637 21.9998H64.8202V0.381044H59.5452V17.701H58.8143L45.3725 0.381044H36.5067Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9513 0.381044V4.67988H77.1667V21.9998H82.4417V4.67988H91.7524V0.381044H67.9513Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3837 21.9998H116.914V17.9191H99.6588V12.966H116.374V9.19678H99.6588V4.46183H116.914V0.381044H94.3837V21.9998Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.842 14.5236C140.842 17.1403 139.761 17.701 136.615 17.701H129.847C126.828 17.701 125.589 17.078 125.589 13.776V8.418C125.589 5.02254 126.319 4.43067 129.847 4.43067H136.615C139.666 4.43067 140.842 5.39635 140.842 7.67038H146.117C146.117 1.59593 142.844 0.131836 137.632 0.131836H128.862C122.379 0.131836 120.313 1.90744 120.313 8.23109V14.3678C120.313 20.1619 122.252 21.9998 128.353 21.9998H138.172C144.687 21.9998 146.117 20.2865 146.148 14.5236H140.842Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.606 0.381044H149.331V21.9998H154.606V12.966H168.239V21.9998H173.514V0.381044H168.239V8.66721H154.606V0.381044Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.07 0.381044H176.795V21.9998H182.07V12.966H195.702V21.9998H200.977V0.381044H195.702V8.66721H182.07V0.381044Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.068 0.381044V14.3055C204.068 19.5389 206.674 21.9998 212.235 21.9998H221.927C227.615 21.9998 229.807 20.0062 229.807 14.3055V0.381044H224.532V13.776C224.532 16.7353 223.293 17.701 220.687 17.701H213.41C210.582 17.701 209.343 16.7976 209.343 13.8071V0.381044H204.068Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M238.307 4.46183H249.048C250.51 4.46183 251.241 5.3029 251.241 6.61124C251.241 8.04419 250.51 9.13448 249.08 9.13448H238.307V4.46183ZM233.032 21.9998H250.001C254.99 21.9998 257.374 20.2865 257.374 15.645C257.374 12.2496 255.976 11.315 253.783 10.5986C255.562 10.0379 256.516 9.29023 256.516 5.80132C256.516 1.81399 253.815 0.381044 248.921 0.381044H233.032V21.9998ZM238.307 12.966H249.08C251.813 12.966 252.099 13.7448 252.099 15.3958C252.099 17.296 251.717 17.9191 248.889 17.9191H238.307V12.966Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintechhub);
export default __webpack_public_path__ + "static/media/fintechhub.65db7f06d204a2ef8264cfd09a41801b.svg";
export { ForwardRef as ReactComponent };